
export const appTableDataSchemas = [
  {
    prop: 'name',
    label: '应用名称',
    minWidth: 80
  },
  {
    prop: 'code',
    label: '应用唯一编码',
    minWidth: 120
  },
  {
    prop: 'remark',
    label: '应用备注说明',
    minWidth: 120
  },
  {
    prop: 'action',
    label: '操作',
    minWidth: 150,
    btnArr: ['update', 'delete']
  }
]

export const classlibtTableDataSchemas = [
  {
    prop: 'fileName',
    label: '文件名称',
    minWidth: 80
  },
  // {
  //   prop: 'type',
  //   label: '应用类型',
  //   minWidth: 120
  // },
  {
    prop: 'fileVersion',
    label: '版本号',
    minWidth: 120
  },
  {
    prop: 'action',
    label: '操作',
    minWidth: 150,
    btnArr: ['replace']
  }
]

export const rules = {
  value: [
    {
      required: true,
      message: '审批人不能为空'
    }
  ],
  level: [
    {
      required: true,
      message: '审批顺序节点不能为空'
    }
  ]
}

// 基础设置 form
export const formSchemas = [
  {
    field: 'name',
    defaultValue: '',
    component: 'Input',
    label: '应用名称',
    rules: [
      {
        required: true,
        message: '应用名称不能为空'
      }
    ]
  },
  {
    field: 'code',
    defaultValue: '',
    component: 'Input',
    label: '应用唯一编码',
    rules: [
      {
        required: true,
        message: '应用唯一编码不能为空'
      }
    ]
  },
  {
    field: 'remark',
    defaultValue: '',
    component: 'InputTextArea',
    label: '应用备注说明',
    rules: [
    ]
  }
]
